import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9a0a95ac&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0a95ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a0a95ac')) {
      api.createRecord('9a0a95ac', component.options)
    } else {
      api.reload('9a0a95ac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9a0a95ac&scoped=true", function () {
      api.rerender('9a0a95ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/index.vue"
export default component.exports